import { Injectable, inject } from '@angular/core';

import {
    InboxService as CoreInboxService,
    InboxState,
    MENU_COUNTERS_PROVIDER,
    MenuAction,
    MenuActionsService,
    MenuCountersService,
    NativeAppService,
    NativeEventType,
    NavigationService,
    OnFeatureInit,
} from '@frontend/vanilla/core';
import { AccountMenuDataService } from '@frontend/vanilla/shared/account-menu';
import { pairwise } from 'rxjs/operators';

import { InboxService } from './services/inbox.service';

@Injectable()
export class InboxBootstrapService implements OnFeatureInit {
    private menuActionsService = inject(MenuActionsService);
    private accountMenuDataService = inject(AccountMenuDataService);
    private menuCountersService = inject(MenuCountersService);
    private inboxService = inject(InboxService);
    private nativeAppService = inject(NativeAppService);
    private accountMenuService = inject(AccountMenuDataService);
    private navigationService = inject(NavigationService);
    private coreInboxService = inject(CoreInboxService);
    private menuCountersProviders = inject(MENU_COUNTERS_PROVIDER);

    onFeatureInit() {
        this.coreInboxService.set(this.inboxService);
        this.menuCountersService.registerProviders(this.menuCountersProviders);
        this.menuActionsService.register(MenuAction.GOTO_INBOX, () => {
            this.inboxService.open({
                showBackButton: this.accountMenuDataService.routerMode,
                trackingEventName: 'Event.inbox.menu_action',
            });
        });

        this.inboxService.count.subscribe((count: number) => {
            this.menuCountersService.update();
            this.nativeAppService.sendToNative({
                eventName: NativeEventType.NotificationCount,
                parameters: {
                    inbox: count,
                },
            });
        });

        this.inboxService.state.pipe(pairwise()).subscribe((params: [InboxState, InboxState]) => {
            this.sendNativeAppEvent(params[1].isOpen);

            if (!params[1].isOpen && params[1].changeSource !== 'back') {
                // if closed after it was open in router mode account menu, close account menu as well
                if (this.accountMenuService.routerModeReturnUrl) {
                    this.navigationService.goTo(this.accountMenuService.routerModeReturnUrl, { isBackNavigation: true });
                }
            }
        });
    }

    private sendNativeAppEvent(visible: boolean) {
        this.nativeAppService.sendToNative({
            eventName: NativeEventType.SENSITIVEPAGE,
            parameters: {
                id: 'inbox',
                type: 'overlay',
                action: visible ? 'open' : 'close',
                isSensitiveForSliderGames: visible,
                isSensitiveForPushNotifications: visible,
            },
        });
    }
}
